import Section from 'Components/ContractGenerator/layouts/Section';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Paragraph } from 'ViatoUi/Shared/Typo';

import Extension from '../../../layouts/Extension';

const Extensions = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');

	const blockedFields = useSelector(contractGeneratorSelectors.getBlockedFields);
	const blockedExtensions = blockedFields?.selectedExtensions?.ids || [];
	const { selectedProduct, selectedExtensions, selectedRooms } = useSelector(contractGeneratorSelectors.getDataToSubmit);

	const extensions = useSelector(contractGeneratorSelectors.getExtensions);
	const product = useSelector(contractGeneratorSelectors.getProduct(selectedProduct.id));

	const extensionsArray = [
		...Object.keys(extensions)
			.sort((a, b) => {
				return extensions[a].sort - extensions[b].sort;
			})
			.map(extension => ({ ...extensions[extension], id: extension }))
	];

	const visibleExtensions = useMemo(() => {
		return extensionsArray.filter(extension => {
			if (
				selectedRooms < extension.displayThresholds.minRooms ||
				selectedRooms > extension.displayThresholds.maxRooms ||
				!product.extensions.includes(Number(extension.id))
			) {
				return false;
			}

			return true;
		});
	}, [product]);

	const getExtensionOption = extension => {
		return extension.options[selectedExtensions.options[extension.id] || extension.selectedOption];
	};

	return (
		<Section headline={t('pages.step2.extensions.headline')} id='viato-contract-generator-extension-selection' darkened>
			{visibleExtensions.map(extension => (
				<Extension
					key={extension.id}
					additionalDescriptions={extension.additionalDescriptions || []}
					buttonSettings={{
						type: selectedExtensions.ids.includes(extension.id) ? 'dark' : 'primary',
						text: selectedExtensions.ids.includes(extension.id) ? t('app.userActions.delete') : t('app.userActions.choose'),
						onClick: () => {
							const selectableExtensionOptions = extension.selectableExtensionOptions || [];
							const selectedExtensionOptions =
								typeof selectedExtensions.selectedExtensionOptions !== 'undefined'
									? {
											...selectedExtensions.selectedExtensionOptions
									  }
									: {};
							let updateExtensions = [...selectedExtensions.ids];

							if (updateExtensions.includes(extension.id)) {
								updateExtensions = updateExtensions.filter(id => {
									if (id === extension.id) {
										return false;
									}
									return true;
								});

								if (selectableExtensionOptions.length > 0) {
									selectedExtensionOptions[extension.id] = [];
								}
							} else {
								updateExtensions = [...updateExtensions, extension.id];

								if (selectableExtensionOptions.length > 0) {
									selectedExtensionOptions[extension.id] = [selectableExtensionOptions[0].options[0]];
								}
							}

							dispatch(
								contractGeneratorOperations.setDataToSubmit({
									selectedExtensions: {
										ids: updateExtensions,
										selectedExtensionOptions
									}
								})
							);
						}
					}}
					extensionDiscountType={getExtensionOption(extension).discount.type}
					extensionDiscountValue={getExtensionOption(extension).discount.value}
					extensionOption={getExtensionOption(extension)}
					feeDiscountType={getExtensionOption(extension).setupFee.discount.type}
					feeDiscountValue={getExtensionOption(extension).setupFee.discount.value}
					hasButton={!blockedExtensions.includes(String(extension.id))}
					id={extension.id}
					infoComponents={extension.infoComponents || []}
					isSinglePayment={getExtensionOption(extension).isSinglePayment}
					selectableExtensionOptions={extension.selectableExtensionOptions || []}
					translationKey={extension.key}
				/>
			))}

			<Spacer height='xl' />
			<Paragraph color='silver' font='normal' centered>
				{t('app.taxInfo')}
			</Paragraph>
		</Section>
	);
};

export default Extensions;
